<template>
    <main>
        <page-header-compact>
            Configuración de Orden de Trabajo
        </page-header-compact>

        <div class="container-fluid px-4">
            <div class="card mt-4">
                <div class="card-body">

                    <data-grid :data="pagination"
                           @changePage="changePage($event)"
                           @perPageChange="perPageChange($event)"
                           @search="search($event)">
                            <template #grid>
                                <grid-table>
                                    <template #head>
                                        <grid-cell-header class="bg-light"  v-for="(h,i) in headers" :key="`h_${i}`">{{h}}</grid-cell-header>
                                    </template>
                                    <template #body>
                                        <grid-row v-for="(item, i) in pagination.data" :key="`d_${i}`">
                                            <grid-cell class="text-center small">
                                                {{item.id}}
                                            </grid-cell>
                                            <grid-cell class="text-center small">
                                              ({{ item.usuario.documento }})  {{item.usuario.nombre_1}} {{item.usuario.nombre_2}} {{item.usuario.apellido_1}} {{item.usuario.apellido_2}}
                                            </grid-cell>
                                            <grid-cell class="text-center small">
                                                {{item.id_orden}}
                                            </grid-cell>
                                            <grid-cell class="text-center small">
                                                {{item.fecha}}
                                            </grid-cell>
                                            <grid-cell class="text-center">
                                                <button class="btn btn-outline-info btn-xs mx-2" type="button" @click="abrirModal(item.id)"  >
                                                      <i class="fas fa-edit fa-fw" ></i> Editar
                                                </button>
                                            </grid-cell>
                                         

                                        </grid-row>
                                    </template>
                                </grid-table>
                            </template>
                            <template #action-button>
                                <button  class="btn btn-info btn-sm shadow-sm mb-2" type="button" data-toggle="modal" data-target="#modalOrdenTrabajo">
                                    Nuevo &nbsp;<i class="fas fa-plus"></i>
                                </button>
                            </template>
                    </data-grid>

                   <modalOrdenTrabajo ref="modalOrdenTrabajo" v-on:cargar-ordenes="getOrdenLaboratorio"></modalOrdenTrabajo>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
import PageHeaderCompact from "../../../../components/layouts/content/page-header-compact";
import DataGrid from "../../../../components/common/utilities/DataGrid/DataGrid";
import GridTable from "../../../../components/common/utilities/DataGrid/GridTable";
import GridCellHeader from "../../../../components/common/utilities/DataGrid/GridCellHeader";
import GridRow from "../../../../components/common/utilities/DataGrid/GridRow";
import GridCell from "../../../../components/common/utilities/DataGrid/GridCell";

import Toast from '../../../../components/common/utilities/toast';
import modalOrdenTrabajo from "./modalOrdenTrabajo";

import ordenTrabajoService from '../../../../services/ordenTrabajoService';

export default {
    components: {
        PageHeaderCompact,GridCell, GridRow, GridCellHeader, GridTable, DataGrid, modalOrdenTrabajo
    },
    data(){
        return {
            ordentrabajo:{},
            headers : [
                '#','Usuario','No. Orden clinica','Fecha','Opción'
           ],
           pagination : {
               data : [],
               current_page : 1,
               page : 1,
               per_page : 5,
               search : '',
               total: '',
           }
        }
    },
    methods : {
        async getOrdenLaboratorio(){
            try {
                this.LoaderSpinnerShow();
                const response = (await ordenTrabajoService.list(this.pagination.search, this.pagination))?.data;
                this.ordentrabajo = response.data;
                console.log(response.data);
                this.pagination.data = response.data;
                this.pagination.current_page  = response.current_page;
                this.pagination.total = response.total;
                this.LoaderSpinnerHide();

            }catch (e) {
                console.error(e);
                Toast.fire({
                    icon: 'error',
                    title: 'Ocurrio un error al procesar la solicitud'
                });
            }
        },
        changePage(page) {
            this.pagination.page = page;
            this.getOrdenLaboratorio();
        },
        perPageChange(per_page) {
            this.pagination.per_page = per_page;
            this.pagination.page = 1;
            this.getOrdenLaboratorio();
        },
        search(query){
            this.pagination.search = query;
            this.pagination.page = 1;
            this.getOrdenLaboratorio();
        },
        abrirModal(id){
           this.$refs.modalOrdenTrabajo.edit(id);
        }

    },
    async created(){
       await this.getOrdenLaboratorio();
    }
}
</script>
